export const copyCode = (text: string, target: string) => {
  navigator.clipboard.writeText(text).then()
  const codeElement: HTMLElement|null = document.querySelector(target)
  if (codeElement && text) {
    codeElement.style.color = '#C2F09C'
    window.setTimeout(() => {
      codeElement.style.color = '#fff'
    }, 200)
  }
}